module.exports = __webpack_public_path__ + "img/pieces.30622103.svg";